import { render, staticRenderFns } from "./WaNameValue.vue?vue&type=template&id=4a2bce30"
import script from "./WaNameValue.vue?vue&type=script&lang=js"
export * from "./WaNameValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports